<template>
  <v-card align="center" justify="center" min-width="27vw" max-width="37vw" outlined>
    <v-card-title>
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title_DeleteEvent') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-7">
      <p style="color:#111111;">{{ $t('description_DeleteEvent') }}</p>
      <p style="background-color: #F1F1F1" class="py-5 mb-5">
        {{ event.name }} - {{ event.description }}<br>
        {{ $t('scheduledAt') }} {{ new Date(event.startDate).toISOString().substring(0, 10) }}
      </p>
      <v-btn @click="deleteEvent">{{ $t('btnDelete_DeleteEvent') }}</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/club';
import { mapMutations } from 'vuex';
export default {
  name: "DeleteEvent",
  props: {
    event: Object,
  },
  methods: {
    ...mapMutations(['setClubEvents']),
    deleteEvent() {
      Repository.deleteEvent(this.event.id).then((response) => {
        if(response.status < 400) {
          alert(this.$t('alert_DeleteEvent'));
          Repository.getAllClubEventsByChannel(this.$store.state.clubMember.club.id, this.$store.state.currentClubChannel.id).then((secondResponse) => {
            if(secondResponse.status < 400)
              this.setClubEvents(secondResponse.data);
            this.close();
          });
        }
      });
    },
    close() {
      this.$emit('closeWindow');
    },
  }
}
</script>



<style scoped>

</style>
